(() => {
  if (window.gpProductInfoReady) return;
  window.gpProductInfoReady = true;
  let active = null;
  const restore = new WeakMap();
  document.addEventListener('click', event => {
    const opener = event.target.closest('[data-gp-info-open]');
    if (opener) {
      const dialog = document.getElementById(opener.dataset.gpInfoOpen);
      if (!dialog || typeof dialog.showModal !== 'function') return;
      event.preventDefault();
      if (active && active !== dialog) active.close();
      if (dialog.open) return;
      const overflow = document.documentElement.style.overflow;
      restore.set(dialog, {opener, overflow});
      try { dialog.showModal(); } catch (e) { restore.delete(dialog); return; }
      active = dialog;
      document.documentElement.style.overflow = 'hidden';
      dialog.addEventListener('close', () => {
        const state = restore.get(dialog);
        restore.delete(dialog);
        if (active === dialog) {
          active = null;
          document.documentElement.style.overflow = state ? state.overflow : '';
        }
        if (state && state.opener.isConnected) state.opener.focus({preventScroll:true});
      }, {once:true});
      return;
    }
    const closer = event.target.closest('[data-gp-info-close]');
    if (closer) {
      const dialog = closer.closest('dialog.gp-product-info-dialog');
      if (dialog && dialog.open) dialog.close();
      return;
    }
    if (active && event.target === active) {
      const rect = active.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) active.close();
    }
  });
  document.addEventListener('shopify:section:unload', event => {
    if (active && event.target.contains(active)) active.close();
  });
})();